import { allSuppliedKeywordText, keywordCatalog } from "./keywordCatalog";

const configuredUrl = process.env["REACT_APP_SITE_URL"] || "https://krent.space";

export { allSuppliedKeywordText, keywordCatalog };

export const seoConfig = {
  siteName: "Krent",
  baseUrl: configuredUrl.replace(/\/$/, ""),
  defaultOgImage: "/logo512.png",
  locale: "en_NG",
  region: "NG",
  twitterHandle: "@krentng",
  defaultKeywords: [
    "real estate in Nigeria",
    "property for rent in Nigeria",
    "property for sale in Nigeria",
    "shortlet apartments in Nigeria",
    "Krent Nigeria",
  ],
} as const;

export type PageSeoKey = "home" | "about" | "contact" | "faq" | "privacy" | "terms";

export type PageSeoMeta = {
  title: string;
  description: string;
  path: string;
  keywords?: string[];
  ogType?: "website" | "article";
  noindex?: boolean;
};

export const pageSeo: Record<PageSeoKey, PageSeoMeta> = {
  home: {
    title: "Shortlet Apartments, Property for Rent & Sale in Nigeria",
    description:
      "Find verified shortlet apartments, properties for rent, and homes for sale in Nigeria. Explore Krent listings in Lagos, Abuja, Lekki, Ikeja, Victoria Island, and more.",
    path: "/",
    keywords: ["shortlet apartments in Lagos", "shortlet apartments in Abuja", "Krent property listings"],
  },
  about: {
    title: "About Krent | Nigeria Real Estate Platform",
    description: "Learn how Krent helps tenants, buyers, landlords, and agents discover and manage verified property listings across Nigeria.",
    path: "/about",
    keywords: ["about Krent", "Krent real estate platform", "Krent Nigeria real estate"],
  },
  contact: {
    title: "Contact Krent | Property and Shortlet Support",
    description: "Contact Krent for help with property listings, shortlet bookings, rentals, and real estate services in Nigeria.",
    path: "/contact",
    keywords: ["contact Krent", "Krent customer service", "Krent shortlet support"],
  },
  faq: {
    title: "Krent FAQ | Property, Rentals and Shortlet Bookings",
    description: "Find answers about Krent property listings, rentals, shortlet bookings, accounts, landlords, agents, and payments.",
    path: "/faq",
    keywords: ["Krent FAQ", "how to book a shortlet in Nigeria", "Krent booking"],
  },
  privacy: {
    title: "Privacy Policy",
    description: "Read the Krent privacy policy and learn how we handle personal information on our real estate platform.",
    path: "/privacy",
  },
  terms: {
    title: "Terms of Use",
    description: "Read the terms governing use of Krent property listings, rental services, and shortlet bookings.",
    path: "/terms",
  },
};

export function absoluteUrl(path: string): string {
  return `${seoConfig.baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
}

export function buildTitle(title: string): string {
  return title.includes(seoConfig.siteName) ? title : `${title} | ${seoConfig.siteName}`;
}
